import { Types } from "../../utils/nodeTypes";
import { ControllerCurrent } from "../current/controllerCurrent";
import { ControllerCircle } from "../circle/controllerCircle";
import { ControllerLine } from "../line/controllerLine";
import { ControllerConnection } from "../connection/controllerConnection";
import { ControllerInputCana } from "../inputCana/controllerInputCana";
import { ControllerInput } from "../input/controllerInput";
import { ControllerArea } from "../area/controllerArea";
import { ControllerSelection } from "../selection/controllerSelection";
import { ControllerText } from "../text/controllerText";
import { ControllerTriangle } from "../triangle/controllerTriangle";
import { ControllerTanque } from "../tanque/controllerTanque";
import { ControllerOccupation } from "../ocupation/controllerOccupation";
import { ControllerMilling } from "../milling/controllerMilling";
import { ControllerBoiler } from "../boiler/controllerBoiler";
import { ControllerSugarCooker } from "../sugarCooker/controllerSugarCooker";
import { ControllerSugarCookerContinuous } from "../sugarCookerContinuous/controllersugarCookerContinuous"
import { ControllerContinuousDorna } from "../continuousDorna/controllerContinuousDorna";
import { ControllerFermentationBatch } from "../FermentationBatch/controllerFermentationBatch";
import { ControllerDistillationColumn2 } from "../distillationColumn2/controllerDistillationColumn2";
import { ControllerDistillationColumnA } from "../distillationColumnA/controllerDistillationColumnA";
import { ControllerDistillationColumnB } from "../distillationColumnB/controllerDistillationColumnB";
import { ControllerCargoLoss } from "../cargoLoss/controllerCargoLoss";
import { ControllerVat } from "../vat/controllerVat";
import { ControllerEthanolCentrifuge } from "../ethanolCentrifuge/controllerEthanolCentrifuge";
import { ControllerDecanter } from "../decanter/controllerDecanter";
import { ControllerDesuperheater } from "../desuperheater/controllerDesuperheater";
import { ControllerFlotador } from "../flotador/controllerFlotador";
import { ControllerDeaerator } from "../deaerator/controllerDeaerator";
import { ControllerEnergyDemand } from "../energyDemand/controllerEnergyDemand";
import { ControllerTurbine } from "../turbine/controllerTurbine";
import { ControllerTowerCO2 } from "../towerCO2/controllerTowerCO2";
import { ControllerFilter3 } from "../filter3/controllerFilter3";
import { ControllerFilterPress } from "../filterPress/controllerFilterPress";
import { ControllerRegeneratorD } from "../regeneratorD/controllerRegeneratorD";
import { ControllerProductionChange } from "../productionChange/controllerProductionChange";
import { ControllerCoolingTower } from "../coolingTower/controllerCoolingTower";
import { ControllerEvaporator } from "../evaporator/controllerEvaporator";
import { ControllerEvaporator2 } from "../evaporator2/controllerEvaporator2";
import { ControllerDiffuser } from "../diffuser/controllerDiffuser";
import { ControllerCombustionReactor } from "../combustionReactor/controllerCombustionReactor";
import { ControllerCrystallizer } from "../crystallizer/controllerCrystallizer";
import { ControllerCaneCleaning } from "../caneCleaning/controllerCaneCleaning";
import { ControllerSprayDryer } from "../sprayDryer/controllerSprayDryer";
import { ControllerMultipleInput } from "../multipleInput/controllerMultipleInput";
import { ControllerBomb } from "../bomb/controllerBomb";
import { ControllerEvaporativeCondenser } from "../evaporativeCondenser/controllerEvaporativeCondenser";
import { ControllerSugarCentrifugue } from "../sugarCentrifugue/controllerSugarCentrifugue";
import { ControllerSugarCentrifugueBatch } from "../sugarCentrifugueBatch/controllerSugarCentrifugueBatch";
import { ControllerHeater } from "../heater/controllerHeater";
import { ControllerLiming } from "../liming/controllerLiming";
import { ControllerDryer } from "../dryer/controllerDryer";
import { ControllerFlash } from "../flash/controllerFlash";
import { ControllerValve } from "../valve/controllerValve";
import { ControllerCondenser } from "../condenser/controllerCondenser";
import { ControllerArrow } from "../arrow/controllerArrow";
import { ControllerStrainer } from "../strainer/controllerStrainer";
import { ControllerSulphitationTower } from "../sulphitationTower/controllerSulphitationTower";
import { ControllerProductionChangeEditable } from "../productionChangeEditable/controllerProductionChangeEditable";
import { ControllerAreaJoker } from "../areaJoker/controllerAreaJoker";
import { ControllerDilutionTank } from "../dilutionTank/controllerDilutionTank";
import { ControllerConcentratorYeast } from "../concentratorYeast/controllerConcentratorYeast";
import { ControllerFinisher } from "../finisher/controllerFinisher";
import { ControllerWasher } from "../washer/controllerWasher";
import { ControllerCentrifugeCitrus } from "../centrifugeCitrus/controllerCentrifugeCitrus";
import { ControllerCellFactory } from "../cellFactory/controllerCellFactory";
import { ControllerEvaporationCitrus } from "../evaporationCitrus/controllerEvaporationCitrus";
import { ControllerScrubber } from "../scrubber/controllerScrubber";
import { ControllerExtractorCitrus } from "../extractorCitrus/controllerExtractorCitrus";
import { ControllerRectangle } from "../rectangle/controllerRectangle";
import { ControllerUltrafiltro } from "../ultrafiltro/controllerUltrafiltro";
import { ControllerPasteurization } from "../pasteurization/controllerPasteurization"
import { ControllerCycloneAndScrubber } from "../cycloneAndScrubber/controllerCycloneAndScrubber"; 
import { ControllerInputCorn } from "../inputCorn/controllerInputCorn"; 
import { ControllerClarifer } from "../clarifer/controllerClarifer"; 
import { ControllerCornCooker } from "../cornCooker/controllerCornCooker"; 
import { ControllerCornDecanter } from "../cornDecanter/controllerCornDecanter"; 
import { ControllerCornLiquefacao } from "../cornLiquefacao/controllerCornLiquefacao"; 
import { ControllerCornMZSA } from "../cornMZSA/controllerCornMZSA"; 
import { ControllerCornDDGS } from "../cornDDGS/controllerCornDDGS"; 
import { ControllerCornMill } from "../CornMill/controllerCornMill"
import { ControllerCitrus } from "../citrus/controllerCitrus"


export let GetNewController = function(type, name) {
  if (type === undefined || type === null) return null;
  let types = new Types();
  switch (type) {
    case types.InputCana:
      return new ControllerInputCana();

    case types.Input:
      return new ControllerInput();

    case types.Area:
      return new ControllerArea(name);

    case types.Current:
      return new ControllerCurrent();

    case types.Circle:
      return new ControllerCircle();

    case types.Line:
      return new ControllerLine();

    case types.Connection:
      return new ControllerConnection();

    case types.Selection:
      return new ControllerSelection();

    case types.Text:
      return new ControllerText();

    case types.Triangle:
      return new ControllerTriangle();

    case types.Tanque:
      return new ControllerTanque();

    case types.Occupation:
      return new ControllerOccupation();

    case types.Milling:
      return new ControllerMilling(name);

    case types.Boiler:
      return new ControllerBoiler();

    case types.SugarCooker:
      return new ControllerSugarCooker();

    case types.SugarCookerContinuous:
      return new ControllerSugarCookerContinuous();

    case types.CargoLoss:
      return new ControllerCargoLoss();

    case types.FermentationBatch:
      return new ControllerFermentationBatch();

    case types.ContinuousDorna:
      return new ControllerContinuousDorna(name);

    case types.DistillationColumnA:
      return new ControllerDistillationColumnA();

    case types.DistillationColumn2:
      return new ControllerDistillationColumn2();

    case types.DistillationColumnB:
      return new ControllerDistillationColumnB(name);

    case types.EthanolCentrifuge:
      return new ControllerEthanolCentrifuge();

    case types.Vat:
      return new ControllerVat();

    case types.EnergyDemand:
      return new ControllerEnergyDemand();

    case types.Turbine:
      return new ControllerTurbine();

    case types.TowerCO2:
      return new ControllerTowerCO2();

    case types.Filter3:
      return new ControllerFilter3();
    
    case types.FilterPress:
      return new ControllerFilterPress();

    case types.Desuperheater:
      return new ControllerDesuperheater();

    case types.Decanter:
      return new ControllerDecanter();

    case types.Flotador:
      return new ControllerFlotador();

    case types.Deaerator:
      return new ControllerDeaerator();

    case types.RegeneratorD:
      return new ControllerRegeneratorD();

    case types.ProductionChange:
      return new ControllerProductionChange();

    case types.Diffuser:
      return new ControllerDiffuser();

    case types.Crystallizer:
      return new ControllerCrystallizer();

    case types.Evaporator:
      return new ControllerEvaporator();

    case types.CoolingTower:
      return new ControllerCoolingTower();

    case types.CaneCleaning:
      return new ControllerCaneCleaning();

    case types.CombustionReactor:
      return new ControllerCombustionReactor();

    case types.SprayDryer:
      return new ControllerSprayDryer();

    case types.Evaporator2:
      return new ControllerEvaporator2();

    case types.MultipleInput:
      return new ControllerMultipleInput();

    case types.Heater:
      return new ControllerHeater();

    case types.EvaporativeCondenser:
      return new ControllerEvaporativeCondenser();

    case types.Bomb:
      return new ControllerBomb();

    case types.SugarCentrifugue:
      return new ControllerSugarCentrifugue();
    
      case types.SugarCentrifugueBatch:
      return new ControllerSugarCentrifugueBatch();

    case types.Liming:
      return new ControllerLiming();

    case types.Dryer:
      return new ControllerDryer();
    
    case types.Flash:
      return new ControllerFlash();

    case types.Valve:
      return new ControllerValve();

    case types.Condenser:
      return new ControllerCondenser();

    case types.Arrow:
      return new ControllerArrow();
      
    case types.Strainer:
      return new ControllerStrainer();
    
    case types.DilutionTank:
      return new ControllerDilutionTank();
    
    case types.ConcentratorYeast:
      return new ControllerConcentratorYeast();
      
    case types.SulphitationTower:
      return new ControllerSulphitationTower();
      
    case types.ProductionChangeEditable:
      return new ControllerProductionChangeEditable();

    case types.AreaJoker:
      return new ControllerAreaJoker();

    case types.Finisher:
      return new ControllerFinisher();

    case types.CentrifugeCitrus:
      return new ControllerCentrifugeCitrus();

    case types.CellFactory:
      return new ControllerCellFactory();

    case types.EvaporationCitrus:
      return new ControllerEvaporationCitrus();

    case types.Washer:
      return new ControllerWasher();

    case types.ExtractorCitrus:
      return new ControllerExtractorCitrus();
    
    case types.Rectangle:
      return new ControllerRectangle();
      
    case types.Ultrafiltro:
      return new ControllerUltrafiltro();

    case types.Pasteurization:
      return new ControllerPasteurization();

    case types.CycloneAndScrubber:
      return new ControllerCycloneAndScrubber();

    case types.Scrubber:
      return new ControllerScrubber();

    case types.InputCorn:
      return new ControllerInputCorn();

    case types.Clarifer:
      return new ControllerClarifer();
    
    case types.CornCooker:
      return new ControllerCornCooker();

    case types.CornDecanter:
      return new ControllerCornDecanter();

    case types.CornLiquefacao:
      return new ControllerCornLiquefacao();

    case types.CornDDGS:
      return new ControllerCornDDGS();

    case types.CornMZSA:
      return new ControllerCornMZSA();
    
    case types.CornMill:
      return new ControllerCornMill();
    
      case types.Citrus:
      return new ControllerCitrus();

    default:
      console.log(`FactoryController: Erro - ${types.Caption[type]}: ${type}  não é um classe disponível para ser instânciada`);
      return null;
  }
};
